module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"ambrosia\"-in-pomona-california-21bcad8e14e0a2712180a69bfcf6e340.png";